export class FindAllProjectRolesError {
  public static readonly type =
    '[Project/ProjectRoles/List] FindAllProjectRolesError';
  constructor(public readonly error: Error) {}
}
